import { Box, Flex, SimpleGrid, useMediaQuery, VStack } from '@chakra-ui/react';
import { FC } from 'react';
import { Else, If, Then } from 'react-if';
import { Outlet } from 'react-router-dom';
import StepperDesktop from './StepperDesktop';
import StepperMobile from './StepperMobile';
import Footer from './Footer';

const PAGE_WIDTH = '500px';

const Layout: FC = () => {
  const [isUpLg] = useMediaQuery('(min-width: 62em)', {
    fallback: true,
  });

  return (
    <If condition={isUpLg}>
      <Then>
        <SimpleGrid columns={2} gap={0} h="full" w="full" margin="auto">
          <Flex align="start" justify="end" py="10vh" position="relative">
            <Box w={PAGE_WIDTH} maxW="full" pr={8}>
              <Outlet />
              <Footer />
            </Box>
          </Flex>

          <Flex align="start" justify="start" py="10vh" backgroundColor="gray.50">
            <Box w={PAGE_WIDTH} maxW="full" pl={8}>
              <StepperDesktop />
            </Box>
          </Flex>
        </SimpleGrid>
      </Then>

      <Else>
        <VStack
          px={6}
          py={8}
          maxW={{ base: 'md', xl: 'lg', sm: 'xl', md: '3xl' }}
          margin="auto"
          spacing={8}
        >
          <StepperMobile />
          <Box flexGrow={1} w="full" mt={2}>
            <Outlet />
          </Box>

          <Footer position="relative" mt={8} mb={2} />
        </VStack>
      </Else>
    </If>
  );
};

export default Layout;
